import { render, staticRenderFns } from "./ModalChangePw.vue?vue&type=template&id=18ee8460&scoped=true&"
import script from "./ModalChangePw.vue?vue&type=script&lang=js&"
export * from "./ModalChangePw.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangePw.vue?vue&type=style&index=0&id=18ee8460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ee8460",
  null
  
)

export default component.exports